/**
 * Created by neo on 21.01.26
 */
import { makeAutoObservable } from 'mobx';
import { FitnessProgramTemplate, createFitnessProgramTemplate } from '../Coach/Program/Template/FitnessProgramTemplate';
import { MindfulnessProgramTemplate, createMindfulnessProgramTemplate } from '../Coach/Mindfulness/Template/MindfulnessProgramTemplate';
import { ExploreEntry } from './ExploreEntry';
import { Recipe, createRecipe } from '../Diet/Recipe/Recipe';
import { ExploreEntryBuilder } from './ExploreEntryBuilder';

export type ExploreWeaviateSearchResultEntry = {
  type: string;
  content?: Recipe | FitnessProgramTemplate | MindfulnessProgramTemplate | ExploreEntry;
};

export function createExploreWeaviateSearchResultEntry(json?: Partial<ExploreWeaviateSearchResultEntry>): ExploreWeaviateSearchResultEntry {
  let content: Recipe | FitnessProgramTemplate | MindfulnessProgramTemplate | ExploreEntry | undefined;
  
  if (json?.type === 'recipe') {
    content = createRecipe(json.content as any);
  } else if (json?.type === 'fitnessProgram') {
    content = createFitnessProgramTemplate(json.content as any);
  } else if (json?.type === 'mindfulnessProgram') {
    content = createMindfulnessProgramTemplate(json.content as any);
  } else if (json?.content) {
    content = ExploreEntryBuilder.build(json.content as any);
  }

  return makeAutoObservable({
    type: json?.type ?? '',
    content,
  });
}
